import { render, staticRenderFns } from "./ActivityFlowCardItem.vue?vue&type=template&id=f883aec4&scoped=true&"
import script from "./ActivityFlowCardItem.vue?vue&type=script&lang=js&"
export * from "./ActivityFlowCardItem.vue?vue&type=script&lang=js&"
import style0 from "./ActivityFlowCardItem.vue?vue&type=style&index=0&id=f883aec4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f883aec4",
  null
  
)

export default component.exports